import { Injectable } from '@angular/core';

@Injectable()
export class RuleActions {

  static CONFIRM_RULE_EXECUTION = "@CONFIRM_RULE_EXECUTION";
}